import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

import { ProductPackageTemplate, ProductPackage } from '@models/models';

interface UpdatedProduct {
	product: ProductPackageTemplate;
	index: number;
}

interface ChosenPackages {
	packages: Array<ProductPackage>;
	discountType: string;
}

@Injectable()
export class ProductPackagesServiceProvider {
	product: BehaviorSubject<ProductPackageTemplate> = new BehaviorSubject(null);
	changedProduct: BehaviorSubject<ProductPackageTemplate> = new BehaviorSubject(
		null
	);
	productToDelete: BehaviorSubject<any> = new BehaviorSubject(null);
	productNames: BehaviorSubject<
		Array<ProductPackageTemplate>
	> = new BehaviorSubject(null);
	chosenPackages: BehaviorSubject<ChosenPackages> = new BehaviorSubject(null);
	packagesStorage: Array<ProductPackageTemplate> = [];

	constructor(public http: HttpClient) {}

	get productObservable() {
		return this.product.asObservable();
	}

	get changedProductObservable() {
		return this.changedProduct.asObservable();
	}

	get productNamesObservable() {
		return this.productNames.asObservable();
	}

	get chosenPackagesObservable() {
		return this.chosenPackages.asObservable();
	}

	get productToDeleteObservable() {
		return this.productToDelete.asObservable();
	}

	emitProduct(product): void {
		this.product.next(product);
	}

	emitProductNames(productNames: Array<ProductPackageTemplate>): void {
		this.productNames.next(productNames);
	}

	emitChangedProduct(product: UpdatedProduct): void {
		this.changedProduct.next(product);
	}

	emitChosenPackages(packages: ChosenPackages): void {
		this.chosenPackages.next(packages);
	}

	emitProductIndexToDelete(product): void {
		this.productToDelete.next(product);
	}

	getPackageFromStorage(id): ProductPackageTemplate {
		return this.packagesStorage[id];
	}

	setPackageInStorage(
		productPackage: ProductPackageTemplate,
		id: number
	): void {
		this.packagesStorage[id] = Object.assign({}, productPackage);
	}

	fetchPackage(packageId: number): Observable<any> {
		const url = `/protected/rest/invoice/package?id=${packageId}`;
		return this.http.get(url);
	}

	getPackagesOnPage(pageRequest) {
		const {
			perPage,
			page,
			pageOrder: { predicate, reverse }
		} = pageRequest;
		const url = '/protected/rest/products';

		let params = new HttpParams();
		params = params.append('perPage', perPage);
		params = params.append('page', page);
		params = params.append('predicate', predicate);
		params = params.append('reverse', reverse);

		return this.http.get(url, { params });
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./mobile/src/providers/product-packages-service/product-packages.data.service.ts